import { useMutation } from 'react-query';
import { apiPost } from './apiService';

const saveFavourites = async ({
  favoriteId,
  displayName
}: {
  favoriteId: number;
  displayName: string;
}): Promise<void> => {
  return apiPost(`favorites/${favoriteId}?fetchPresence=false`, { favoriteId, displayName });
};

const useFavouritesRenameMutation = () => {
  return useMutation({
    mutationFn: saveFavourites,
    mutationKey: ['useFavouritesRenameMutation']
  });
};

export default useFavouritesRenameMutation;
